import React, { useState } from 'react';
import { Lock, CaretUp, CaretDown } from '@phosphor-icons/react';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from './ui/collapsible';

export function CollapsibleSection({ title, icon: Icon, content, defaultOpen = false, locked = false, language = 'en', testId }) {
  const [open, setOpen] = useState(defaultOpen && !locked);

  if (locked) {
    return (
      <div className="pp-card opacity-60" data-testid={`${testId}-locked`}>
        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-3 min-w-0">
            <Icon size={20} className="text-pp-text-muted shrink-0" weight="duotone" aria-hidden="true" />
            <span className="font-medium text-pp-text-muted break-words" data-testid={`${testId}-title`}>{title}</span>
          </div>
          <Lock size={16} className="text-pp-text-muted shrink-0" aria-hidden="true" />
        </div>
        <div className="mt-3 pt-3 border-t border-pp-border" aria-hidden="true">
          <div className="h-4 bg-pp-secondary/70 rounded w-full mb-2" />
          <div className="h-4 bg-pp-secondary/50 rounded w-3/4" />
        </div>
      </div>
    );
  }

  return (
    <Collapsible open={open} onOpenChange={setOpen} data-testid={testId}>
      <div className="pp-card">
        <CollapsibleTrigger type="button" className="w-full flex items-center justify-between gap-3 rounded text-left focus-ring" data-testid={`${testId}-toggle`}>
          <div className="flex items-center gap-3 min-w-0 flex-1">
            <Icon size={20} className="text-pp-navy shrink-0" weight="duotone" aria-hidden="true" />
            <span className="font-medium text-pp-text break-words min-w-0" data-testid={`${testId}-title`}>{title}</span>
          </div>
          {open ? (
            <CaretUp size={18} className="text-pp-text-muted shrink-0" aria-hidden="true" />
          ) : (
            <CaretDown size={18} className="text-pp-text-muted shrink-0" aria-hidden="true" />
          )}
        </CollapsibleTrigger>
        <CollapsibleContent data-testid={`${testId}-content`}>
          <div className="mt-4 pt-4 border-t border-pp-border">
            <div className="text-pp-text-secondary leading-relaxed break-words">{content}</div>
          </div>
        </CollapsibleContent>
      </div>
    </Collapsible>
  );
}